export const getAnxietyLevel: (anxietyLevel: number) => string = (anxietyLevel: number) => {
    switch (anxietyLevel) {
        case 0:
            return "minimal";
        case 1:
            return "mild";
        case 2:
            return "moderate";
        case 3:
            return "severe";
        default:
            return "Unknown";
    }
};

export const getDepressionLevel: (depressionLevel: number) => string = (depressionLevel: number) => {
    switch (depressionLevel) {
        case 0:
            return "none/minimal";
        case 1:
            return "mild";
        case 2:
            return "moderate";
        case 3:
            return "moderately severe";
        case 4:
            return "severe";
        case 5:
            return "risk of suicide ideation";
        default:
            return "Unknown";
    }
};

export const getWellBeingLevel: (wellBeingLevel: number) => string = (wellBeingLevel: number) => {
    switch (wellBeingLevel) {
        case 0:
            return "low";
        case 1:
            return "average";
        case 2:
            return "high";
        default:
            return "Unknown";
    }
};

export const getClimateChangeAnxietyLevel: (climateChangeAnxietyLevel: number) => string = (climateChangeAnxietyLevel: number) => {
    switch (climateChangeAnxietyLevel) {
        case 0:
            return "low";
        case 1:
            return "moderate";
        case 2:
            return "high";
        case 3:
            return "severe";
        default:
            return "Unknown";
    }
};

export const getResilenceLevel: (resilienceLevel: number) => string = (resilienceLevel: number) => {
    switch (resilienceLevel) {
        case 0:
            return "low";
        case 1:
            return "average";
        case 2:
            return "high";
        default:
            return "Unknown";
    }
};